import { render, staticRenderFns } from "./RuralGrazingFarm.vue?vue&type=template&id=0b56a007&scoped=true&"
import script from "./RuralGrazingFarm.vue?vue&type=script&lang=ts&"
export * from "./RuralGrazingFarm.vue?vue&type=script&lang=ts&"
import style0 from "./RuralGrazingFarm.vue?vue&type=style&index=0&id=0b56a007&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b56a007",
  null
  
)

export default component.exports